(() => {

  /* =========================================================
     NAVIGATION
     ========================================================= */

 const initPwlUdkPdpNavigation = () => {

  const nav =
    document.querySelector('.pwl-udk-pdp-header__nav');

  if (!nav) return;


  const links =
    Array.from(
      nav.querySelectorAll(
        '.pwl-udk-pdp-header__nav-link'
      )
    );

  if (!links.length) return;


  /* =====================================================
     DEFAULT ACTIVE ON PAGE LOAD
     ===================================================== */

  const hasActive =
    links.some(link =>
      link.classList.contains('is-active')
    );

  if (!hasActive) {
    links[0].classList.add('is-active');
  }


  /* Avoid duplicate event listeners */

  if (nav.dataset.pwlNavInitialized === 'true') {
    return;
  }

  nav.dataset.pwlNavInitialized = 'true';


  /* =====================================================
     CLICK
     ===================================================== */

  nav.addEventListener('click', event => {

    const link =
      event.target.closest(
        '.pwl-udk-pdp-header__nav-link'
      );

    if (!link) return;


    const rawHref =
      link.getAttribute('href');

    if (!rawHref) return;


    const targetId =
      rawHref
        .replace(/^#+/, '')
        .trim();

    if (!targetId) return;


    const target =
      document.getElementById(targetId);

    if (!target) {
      console.warn(
        'PWL navigation target not found:',
        targetId
      );

      return;
    }


    event.preventDefault();


    /* Active line */

    links.forEach(item => {
      item.classList.remove('is-active');
    });

    link.classList.add('is-active');


    /* Smooth scroll */

    const headerOffset =
      window.innerWidth < 750
        ? 64
        : 80;


    const targetTop =
      target.getBoundingClientRect().top +
      window.scrollY -
      headerOffset;


    window.scrollTo({
      top: targetTop,
      behavior: 'smooth'
    });

  });

};

  /* =========================================================
     BUY BOX SWIPER
     ========================================================= */

  const initPwlUdkPdpBuyboxes = () => {

    if (typeof window.Swiper === 'undefined') {
      return false;
    }

    document
      .querySelectorAll('[data-pwl-udk-pdp-buybox]')
      .forEach(section => {

        if (section.dataset.pwlSwiperInitialized === 'true') {
          return;
        }

        const mainElement =
          section.querySelector('[data-pwl-pdp-main-swiper]');

        const thumbsElement =
          section.querySelector('[data-pwl-pdp-thumb-swiper]');

        const paginationElement =
          section.querySelector(
            '[data-pwl-pdp-gallery-pagination]'
          );

        if (!mainElement) {
          return;
        }


        let thumbsSwiper = null;


        if (thumbsElement) {

          thumbsSwiper = new window.Swiper(
            thumbsElement,
            {
              slidesPerView: 'auto',
              spaceBetween: 8,

              watchSlidesProgress: true,

              freeMode: true,

              slideToClickedSlide: true,

              breakpoints: {
                0: {
                  spaceBetween: 6
                },

                750: {
                  spaceBetween: 8
                }
              }
            }
          );

        }


        new window.Swiper(
          mainElement,
          {
            slidesPerView: 1,

            spaceBetween: 0,

            speed: 350,

            grabCursor: true,

            watchOverflow: true,

            keyboard: {
              enabled: true
            },

            pagination: paginationElement
              ? {
                  el: paginationElement,
                  clickable: true
                }
              : false,

            thumbs: thumbsSwiper
              ? {
                  swiper: thumbsSwiper
                }
              : undefined
          }
        );


        section.dataset.pwlSwiperInitialized = 'true';

      });


    return true;

  };

    /* =========================================================
     ACCORDIONS
     ========================================================= */

  const initPwlUdkPdpAccordions = () => {

    document
      .querySelectorAll('.pwl-udk-pdp-buybox')
      .forEach(section => {

        const accordions =
          section.querySelectorAll(
            '.pwl-udk-pdp-buybox__accordion'
          );

        accordions.forEach(accordion => {

          if (
            accordion.dataset.pwlAccordionInit === 'true'
          ) {
            return;
          }

          accordion.dataset.pwlAccordionInit = 'true';

          accordion.addEventListener('toggle', () => {

            if (!accordion.open) {
              return;
            }

            accordions.forEach(otherAccordion => {

              if (otherAccordion !== accordion) {
                otherAccordion.open = false;
              }

            });

          });

        });

      });

  };

/* =========================================================
   FAQ ACCORDIONS
   ========================================================= */

const initPwlUdkPdpFaq = () => {

  document
    .querySelectorAll('[data-pwl-udk-pdp-faq]')
    .forEach(section => {

      const items =
        section.querySelectorAll('.pwl-udk-pdp-faq__item');

      items.forEach(item => {

        if (item.dataset.pwlFaqInit === 'true') {
          return;
        }

        item.dataset.pwlFaqInit = 'true';

        item.addEventListener('toggle', () => {

          if (!item.open) {
            return;
          }

          items.forEach(otherItem => {

            if (otherItem !== item) {
              otherItem.open = false;
            }

          });

        });

      });

    });

};

/* =========================================================
   PRODUCTS / LAYERS SWIPER
   ========================================================= */

const initPwlUdkPdpLayers = () => {

  if (typeof window.Swiper === 'undefined') {
    return false;
  }

  document
    .querySelectorAll('[data-pwl-udk-pdp-layers]')
    .forEach(section => {

      if (section.dataset.pwlLayersInit === 'true') {
        return;
      }

      const swiperElement =
        section.querySelector('[data-pwl-pdp-layers-swiper]');

      const progressElement =
        section.querySelector('[data-pwl-pdp-layers-progress]');

      const prevButton =
        section.querySelector('[data-pwl-pdp-layers-prev]');

      const nextButton =
        section.querySelector('[data-pwl-pdp-layers-next]');

      if (!swiperElement) {
        return;
      }

      new window.Swiper(swiperElement, {

        slidesPerView: 'auto',

        spaceBetween: 24,

        speed: 450,

        grabCursor: true,

        watchOverflow: true,

        navigation: {
          prevEl: prevButton,
          nextEl: nextButton
        },

        pagination: progressElement
          ? {
              el: progressElement,
              type: 'progressbar'
            }
          : false,

        breakpoints: {

          0: {
            spaceBetween: 16
          },

          750: {
            spaceBetween: 24
          }

        }

      });

      section.dataset.pwlLayersInit = 'true';

    });

  return true;
};

/* =========================================================
   HOW IT WORKS SWIPER
   ========================================================= */

const initPwlUdkPdpHow = () => {

  if (typeof window.Swiper === 'undefined') {
    return false;
  }

  document
    .querySelectorAll('[data-pwl-udk-pdp-how]')
    .forEach(section => {

      if (section.dataset.pwlHowInit === 'true') {
        return;
      }

      const swiperElement =
        section.querySelector('[data-pwl-pdp-how-swiper]');

      const progressElement =
        section.querySelector('[data-pwl-pdp-how-progress]');

      const prevButton =
        section.querySelector('[data-pwl-pdp-how-prev]');

      const nextButton =
        section.querySelector('[data-pwl-pdp-how-next]');

      if (!swiperElement) {
        return;
      }

      new window.Swiper(swiperElement, {

        slidesPerView: 'auto',

        spaceBetween: 24,

        speed: 450,

        grabCursor: true,

        watchOverflow: true,

        navigation: {
          prevEl: prevButton,
          nextEl: nextButton
        },

        pagination: progressElement
          ? {
              el: progressElement,
              type: 'progressbar'
            }
          : false,

        breakpoints: {

          0: {
            spaceBetween: 16
          },

          750: {
            spaceBetween: 24
          }

        }

      });

      section.dataset.pwlHowInit = 'true';

    });

  return true;
};

/* =========================================================
   STICKY ADD TO CART
   ========================================================= */

const initPwlUdkPdpStickyAtc = () => {

  let sticky =
    document.querySelector('[data-pwl-udk-pdp-sticky]');

  const mainButton =
    document.querySelector(
      '.pwl-udk-pdp-buybox .pwl-udk-pdp-buybox__atc'
    );

  if (!sticky || !mainButton) {
    return;
  }


  /*
   * IMPORTANT:
   * Move sticky outside Shopify section wrappers.
   * This prevents transformed / overflow parents
   * from trapping position: fixed.
   */
  if (sticky.parentElement !== document.body) {
    document.body.appendChild(sticky);
  }


  if (sticky.dataset.pwlStickyInit === 'true') {
    return;
  }

  sticky.dataset.pwlStickyInit = 'true';


  const updateSticky = () => {

    const buttonRect =
      mainButton.getBoundingClientRect();

    /*
     * Show as soon as the MAIN buybox ATC
     * has passed above the viewport.
     */
    const shouldShow =
      buttonRect.bottom <= 0;


    if (shouldShow) {

      sticky.classList.add('is-visible');

      sticky.setAttribute(
        'aria-hidden',
        'false'
      );

    } else {

      sticky.classList.remove('is-visible');

      sticky.setAttribute(
        'aria-hidden',
        'true'
      );

    }

  };


  let ticking = false;

  const requestUpdate = () => {

    if (ticking) {
      return;
    }

    ticking = true;

    requestAnimationFrame(() => {

      updateSticky();

      ticking = false;

    });

  };


  window.addEventListener(
    'scroll',
    requestUpdate,
    { passive: true }
  );

  window.addEventListener(
    'resize',
    requestUpdate
  );


  updateSticky();

};

/* =========================================================
   HIDE STICKY WHEN INLINE CTA IS VISIBLE
   ========================================================= */
const initPwlUdkPdpStickyInlineVisibility = () => {

  const sticky =
    document.querySelector('[data-pwl-udk-pdp-sticky]');

  if (!sticky) return;

  if (sticky.dataset.pwlInlineCtaObserver === 'true') {
    return;
  }

  sticky.dataset.pwlInlineCtaObserver = 'true';


  const inlineCtas =
    Array.from(
      document.querySelectorAll(`
        .pwl-udk-pdp-buybox__atc,
        .pwl-udk-pdp-layers__atc,
        .pwl-udk-pdp-how__atc,
        .pwl-udk-pdp-compare__atc,
        .pwl-udk-pdp-value__atc
      `)
    );


  /* -----------------------------------------
     GET ACTUAL LAST SECTION = FOOTER
     ----------------------------------------- */

  const template =
    document.querySelector('.pwl-udk-pdp-template');

  const footer =
    document.querySelector(
      '#shopify-section-pwl-udk-pdp-footer'
    )
    ||
    document.querySelector(
      '[id*="pwl-udk-pdp-footer"]'
    )
    ||
    (
      template
        ? template.lastElementChild
        : null
    );


  const visibleCtas = new Set();

  let footerVisible = false;


  const updateStickyVisibility = () => {

    sticky.classList.toggle(
      'is-inline-cta-visible',
      visibleCtas.size > 0 || footerVisible
    );

  };


  /* -----------------------------------------
     INLINE CTA OBSERVER
     ----------------------------------------- */

  const ctaObserver =
    new IntersectionObserver(
      entries => {

        entries.forEach(entry => {

          if (entry.isIntersecting) {
            visibleCtas.add(entry.target);
          } else {
            visibleCtas.delete(entry.target);
          }

        });

        updateStickyVisibility();

      },
      {
        threshold: 0.15
      }
    );


  inlineCtas.forEach(cta => {
    ctaObserver.observe(cta);
  });


  /* -----------------------------------------
     FOOTER OBSERVER
     ----------------------------------------- */

  if (footer) {

    const footerObserver =
      new IntersectionObserver(
        entries => {

          entries.forEach(entry => {

            footerVisible =
              entry.isIntersecting;

          });

          updateStickyVisibility();

        },
        {
          threshold: 0.01
        }
      );

    footerObserver.observe(footer);

  }

};
/* =========================================================
   ALL CTA BUTTONS → SMOOTH SCROLL TO SHOP / BUYBOX
   ========================================================= */

const initPwlUdkPdpCtaScroll = () => {

  const shopSection =
    document.querySelector('#pwl-pdp-product-info');

  if (!shopSection) return;


  const ctaSelectors = [
    '.pwl-udk-pdp-layers__atc',
    '.pwl-udk-pdp-how__atc',
    '.pwl-udk-pdp-compare__atc',
    '.pwl-udk-pdp-value__atc',
    '.pwl-udk-pdp-sticky__button'
  ];


  document
    .querySelectorAll(ctaSelectors.join(','))
    .forEach(button => {

      if (button.dataset.pwlShopScrollInit === 'true') {
        return;
      }

      button.dataset.pwlShopScrollInit = 'true';


      button.addEventListener('click', event => {

        event.preventDefault();

        shopSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });

      });

    });

};
  /* =========================================================
     INIT
     ========================================================= */

   const initPwlUdkPdp = () => { 
 
   initPwlUdkPdpNavigation();
initPwlUdkPdpAccordions();
initPwlUdkPdpFaq();
initPwlUdkPdpLayers();
initPwlUdkPdpStickyAtc();
initPwlUdkPdpStickyInlineVisibility();
initPwlUdkPdpCtaScroll();
 
    let attempts = 0;

    const waitForSwiper = () => {

      attempts += 1;
const initialized =
  initPwlUdkPdpBuyboxes();

const layersInitialized =
  initPwlUdkPdpLayers();

const howInitialized =
  initPwlUdkPdpHow();

if (
  (!initialized || !layersInitialized || !howInitialized) &&
  attempts < 30
) {
  setTimeout(waitForSwiper, 100);
}

    };

    waitForSwiper();

  };


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initPwlUdkPdp
    );

  } else {

    initPwlUdkPdp();

  }


  /* SHOPIFY THEME EDITOR */

  document.addEventListener(
    'shopify:section:load',
    () => {
      initPwlUdkPdp();
    }
  );

})();


/* =========================================================
   MOVE AFTERPAY / SQUARE PLACEMENT BELOW ATC
   ========================================================= */

const movePwlUdkAfterpay = () => {
  document
    .querySelectorAll('.pwl-udk-pdp-buybox')
    .forEach((buybox) => {

      const button =
        buybox.querySelector('.pwl-udk-pdp-buybox__atc');

      const afterpay =
        buybox.querySelector('square-placement');

      if (!button || !afterpay) {
        return;
      }

      afterpay.classList.add(
        'pwl-udk-pdp-buybox__afterpay'
      );

      /*
       * Ako već nije odmah ispod dugmeta,
       * premesti ga tamo.
       */
      if (button.nextElementSibling !== afterpay) {
        button.insertAdjacentElement(
          'afterend',
          afterpay
        );
      }

    });
};


/* odmah */
movePwlUdkAfterpay();


/* nakon load-a */
window.addEventListener(
  'load',
  movePwlUdkAfterpay
);


/* Afterpay se učitava dinamički */
const pwlUdkAfterpayObserver =
  new MutationObserver(() => {
    movePwlUdkAfterpay();
  });

pwlUdkAfterpayObserver.observe(
  document.body,
  {
    childList: true,
    subtree: true
  }
);